import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blankcomponent',
  templateUrl: './blankcomponent.component.html',
  styleUrls: ['./blankcomponent.component.css']
})
export class BlankcomponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
